import React from 'react';
import Offcanvas, { OffcanvasProps } from 'react-bootstrap/Offcanvas';

import WorkspaceBotoes from '../WorkspaceBotoes';
import styles from './offcanvasFlex.module.css';

interface OffCanvasFlexProps extends Omit<OffcanvasProps, 'children'> {
  show: boolean;
  onHide: () => void;
  tituloCanvas: string;
  style?: React.CSSProperties;
  botaoAbrir?: boolean;
  rotaAbrir?: string;
  children: React.ReactNode;
  footerContent?: React.ReactNode;
}

const OffCanvasFlex: React.FC<OffCanvasFlexProps> = ({
  show,
  onHide,
  tituloCanvas,
  style,
  botaoAbrir = true,
  rotaAbrir,
  children,
  footerContent,
  ...restProps
}) => {
  const handleAbrirRota = () => {
    if (rotaAbrir) {
      window.open(rotaAbrir, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <Offcanvas
      show={show}
      onHide={onHide}
      placement="end"
      style={style}
      {...restProps}
    >
      {/* Container principal com layout em grid de 3 linhas */}
      <div className={styles.offcanvasContainer}>
        {/* Cabeçalho: exibe título e botão de fechar */}
        <div className={styles.header}>
          <span className={styles.headerTitle}>{tituloCanvas}</span>
          <button
            type="button"
            className="btn-close btn-close-white"
            aria-label="Fechar"
            onClick={onHide}
          />
        </div>

        {/* Corpo: área de conteúdo personalizável via children */}
        <div className={styles.body}>{children}</div>

        {/* Rodapé: contém botões de ação e conteúdo adicional opcional */}
        <div className={styles.footer}>
          {/* Renderiza conteúdo adicional do rodapé à esquerda, se fornecido */}
          {footerContent && (
            <div className={styles.footerContentLeft}>{footerContent}</div>
          )}

          {/* Botão de abertura em nova aba, posicionado à direita */}
          {botaoAbrir && (
            <div className={styles.footerContentRight}>
              <WorkspaceBotoes open onClickOpen={handleAbrirRota} />
            </div>
          )}
        </div>
      </div>
    </Offcanvas>
  );
};

export default OffCanvasFlex;
